import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Options } from 'selenium-webdriver/chrome';

const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' })};

@Injectable()
export class TramiteService {

  // private apiUrl = 'http://10.100.15.128:623/ServicioConsultaRCApi.svc/api/datoslegalizacion';
  // private apiUrl2 = 'http://10.100.15.128:623/ServicioConsultaRCApi.svc/api/reportelegalizacion';
  // private apiUrl = 'http://10.100.15.125:124/ServicioConsultaRCApi.svc/api/datoslegalizacion';
  // private apiUrl2 = 'http://10.100.15.125:124/ServicioConsultaRCApi.svc/api/reportelegalizacion';
  private apiUrl = 'http://swconsultatramite.oep.org.bo/api/ConsultaRc/PostConsultaTramite';
  private apiUrl2 = 'http://swconsultatramite.oep.org.bo/api/ConsultaRc/PostDocumentoPdf';

  constructor(private http: HttpClient) { }

  obtenerTramite(busquedaTramite: BusquedaTramite): Observable<DatosTramite> {
    return this.http.post<DatosTramite>(this.apiUrl, busquedaTramite, httpOptions).pipe();
  }

  obtenerDocumento(busquedaTramite: BusquedaTramite):  Observable<DocumentoPDF> {
    return this.http.post<DocumentoPDF>(this.apiUrl2, busquedaTramite, httpOptions).pipe();
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }

  private log(mensaje: string) {
    console.log('TramiteService: ' + mensaje);
  }
}

export interface BusquedaTramite {
  CodigoTramite: string;
  TipoTramite: string;
  ValidaEstadoSolicitud: boolean;
}

export interface DatosTramite {
  CelSolicitante: string;
  CiSolicitante: string;
  DatosSolicitante: string;
  EstadoTramite: string;
  FechaSolicitud: string;
  FuncionarioRecepcion: string;
  MailSolicitante: string;
  ObservacionTramite: string;
  OficinaRecepcion: string;
  TipoTramite: string;
}

export interface DocumentoPDF {
  base64: string;
}



// WEBPACK FOOTER //
// ./src/app/services/tramite.service.ts